import differenceInWeeks from 'date-fns/difference_in_weeks';
import differenceInMonths from 'date-fns/difference_in_months';

function hasMoreThanTen(state) {
    const { moreThanTen } = state;
    const hasMoreThanTen = (moreThanTen === 1);
    return hasMoreThanTen;
};

function hasStarted6MonthsAgo(state) {
    const { startDate } = state;
    const today = new Date();
    const start = startDate;
    return differenceInMonths(today, start) >= 6;
}

function is3WeeksAgo(state) {
    const { receiptDate } = state;
    const today = new Date();
    const receipt = receiptDate;
    return differenceInWeeks(today, receipt) >= 3;
}

function isInstantTermination(state) {
    const { kindOf } = state;
    const isInstantTermination = (kindOf === 1);
    return isInstantTermination;
}

export {
    is3WeeksAgo,
    hasMoreThanTen,
    hasStarted6MonthsAgo,
    isInstantTermination,
}


// WEBPACK FOOTER //
// ./src/functions/protection-calculator.js